var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "crud crud-list" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { novalidate: "novalidate" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return (function () {})($event)
          },
        },
      },
      [
        _c(
          "fieldset-component",
          { attrs: { title: "Log Level", collapsed: false } },
          [
            _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
              _c(
                "form",
                {
                  attrs: { novalidate: "novalidate" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.updateLogLevel($event)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-10" }, [
                      _c("span", { staticStyle: { "font-size": "18px" } }, [
                        _vm._v("Log Level Atual: " + _vm._s(_vm.logLevel)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.errors.first("newLogLevel"),
                              expression: "errors.first('newLogLevel')",
                            },
                          ],
                          staticClass: "form-group",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "newLogLevel" },
                            },
                            [
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("*"),
                              ]),
                              _vm._v(
                                "\n                                    New Log Level\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            attrs: {
                              id: "newLogLevel",
                              name: "newLogLevel",
                              data: _vm.newLogLevelOptions,
                            },
                            model: {
                              value: _vm.newLogLevel,
                              callback: function ($$v) {
                                _vm.newLogLevel = $$v
                              },
                              expression: "newLogLevel",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-12 newbtn" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "submit" },
                          },
                          [_vm._v(_vm._s(_vm.$t("__.Crud.salvar")))]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "fieldset-component",
          { attrs: { title: "Cache", collapsed: false } },
          [
            _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.limparCacheProdutos },
                },
                [
                  _vm._v(
                    "\n                    Limpar Cache do Produtos\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  attrs: { type: "button" },
                  on: { click: _vm.limparCacheProdutosManipulacao },
                },
                [
                  _vm._v(
                    "\n                    Limpar Cache do Produtos Manipulação\n                "
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "fieldset-component",
          { attrs: { title: "Feature Flags", collapsed: false } },
          [
            _c(
              "div",
              { attrs: { slot: "rows" }, slot: "rows" },
              [
                _c("grid-component", {
                  ref: "gridcomponent",
                  attrs: {
                    showSearchField: false,
                    showTools: false,
                    showAddNewButton: false,
                    showActionColumn: false,
                    showSortIcons: false,
                    columns: _vm.gridColumns,
                    data: _vm.gridData,
                    tituloPagina: "Feature Flags",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-div" }, [
      _c("h1", { staticClass: "title" }, [_vm._v("Administração")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }